module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-left-d2f13cd4eb204ea5c976d0f1e0544edc.svg";